import { Edge } from "react-flow-renderer";

export const getEdgeId = <T = any>(
  payload: Pick<Edge<T>, "source" | "sourceHandle" | "target" | "targetHandle">
) =>
  `${payload.source}-${payload.sourceHandle}-${payload.target}-${payload.targetHandle}`;
